import { EmployeesList } from './EmployeesList';

export default EmployeesList;
